import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import { userUpdate, fetchUser } from '../../features/dashboard/UserManagmentSlice';
import Header from './Header';
import Broadcast from './Broadcast';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';

function UserManagment () {
    const {id} = useParams()
    const userName = useRef();
    const mobile = useRef();
    const password = useRef()
    const nationalId = useRef()
    
    const [FlagStatus, setFlag] = useState(false)
    const flag = useRef(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    let {
        UserMainperson,
        UserMainsuccess,
        UserMainstatus,
        UserMainloading,
        UserMainmessage,
        UserMainerrorName,
        UserMainerrorMobile,
        UserMainerrorNationalId,
        UserMainerrorFlag,
        UserMainerrorPassword
    } = useSelector(state => state.userManagment)

    const userUdateHandler = (event) => {
        event.preventDefault();
        const data = {
            'id': id,
            'name': userName.current.value,
            'mobile': mobile.current.value,
            'password': password.current.value,
            'national_id': nationalId.current.value,
            'flag': FlagStatus == true ? '1' : null,
        }
        dispatch(userUpdate(data));
        
    }
    const flagHandler = () => {

    }
    const goToUserIndex = () => {
        navigate('/dashboard/user/index', { replace: true })
    }



    useEffect(() => {
        UserMainerrorName = ''
        UserMainerrorMobile = ''
        UserMainerrorFlag = ''
        UserMainerrorPassword = ''
        dispatch(fetchUser(id))
    },[])

    useEffect(() => {
        if(UserMainsuccess === true){
            setFlag(UserMainperson.status == '1' ? true : false);
        }
    },[UserMainperson])

    useEffect(() => {
        console.log(UserMainperson);
        if(UserMainsuccess === true && UserMainstatus === true && UserMainloading === false && UserMainmessage != "") {
            toast.success(UserMainmessage,{
                position: "top-center",
                autoClose: 1200,
              })
              UserMainmessage = ''
        }

        if(UserMainsuccess === false && UserMainstatus === false && UserMainloading === false && UserMainmessage != "") {
            toast.error(UserMainmessage,{
                position: "top-center",
                autoClose: 1200,
              })
              UserMainmessage = ''
        }
    },[UserMainloading,UserMainsuccess, UserMainmessage])

    return (
        <>
        { UserMainloading ? (<Loading />) : null}
        <Broadcast title={'ویرایش کاربر'} />
        <form className="text-end  ">
        <div className='row rahpardaznet-cart my-5 print-position'>
                <div className=" row col-12">
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                            نام کاربر
                            </label>
                                <input
                                    tabIndex="1" 
                                    type="text"
                                    defaultValue={UserMainperson.name} 
                                    ref={userName}
                                    className="form-control shadow-none" 
                                    id="staticName" 
                                    autoFocus
                                />
                                {
                                    (UserMainerrorName) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{ UserMainerrorName }</small>
                                    </span>
                                ):''}
                            </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticName" className="fw-bold text-end form-label px-1">
                             کدملی
                            </label>
                                <input
                                    tabIndex="1" 
                                    type="text"
                                    defaultValue={UserMainperson.nationalId} 
                                    ref={nationalId}
                                    className="form-control shadow-none" 
                                    id="staticName" 
                                    autoFocus
                                />
                                {
                                    (UserMainerrorNationalId) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger validate-error'>{ UserMainerrorNationalId }</small>
                                    </span>
                                ):''}
                            </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticMobile" className="fw-bold text-end form-label px-1">
                            موبایل
                            </label>
                            <input
                                tabIndex="2" 
                                type="text"
                                defaultValue={UserMainperson.mobile}
                                ref={mobile}
                                className="form-control shadow-none text-left ltr" 
                                id="staticEmail" 
                            />
                            {
                                (UserMainerrorMobile) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ UserMainerrorMobile }</small>
                                </span>
                            ):''}
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="m-3 rahpardaznet-form-controll">
                            <label forhtml="staticPassword" className="fw-bold text-end form-label px-1">
                            گذرواژه
                            </label>
                            <input
                                autoComplete='new-password'
                                tabIndex="3" 
                                type="password"
                                ref={password}
                                className="form-control shadow-none" 
                                id="staticPassword" 
                                placeholder="در صورت تغیر گذرواژه جدید را وارد کنید" 
                            />
                            {
                                (UserMainerrorPassword) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ UserMainerrorPassword }</small>
                                </span>
                            ):''}
                        </div>
                    </div> 
                    <div className="col-12 p-4 d-flex flex-reverse">
                        <div className='form-check form-switch form-check-reverse'>
                           
                            <input 
                                tabIndex='4'
                                name='flag'
                                type="checkbox"
                                checked={FlagStatus === true ? 'checked' : false}
                                className="form-check-input" 
                                role="switch" 
                                onChange={(e) => setFlag(e.target.checked)} 

                            /> 
                           {
                                (FlagStatus) ? (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-success'>فعال</strong>
                                    </label>
                                ) : (
                                    <label className="form-check-label px-2" forhtml="flexSwitchCheckDefault">
                                    <strong className='text-danger'>غیرفعال</strong>
                                </label>
                                )
                            }
                           
                            
                            {
                                (UserMainerrorFlag) ? (
                                <span className="help-block fw-bold d-inline-block mt-2">
                                    <small className='text-danger validate-error'>{ UserMainerrorFlag }</small>
                                </span>
                            ):''}                                        
                        </div>
                    </div>  
                    
                    
                </div>
            </div>
        </form>
        <div className="row p-0">
                        <div className='col-12 p-0'>
                        <Button
                            tab='2'
                            title='برگشت به صفحه کاربران'
                            design="rahpardaznet-button outline"
                            event={goToUserIndex}
                        />
                        <Button
                            tab='1'
                            title='ویرایش کاربر'
                            design="rahpardaznet-button"
                            event={userUdateHandler}
                        />
                        </div>
                    </div>
        </>
    )
}

export default UserManagment;